export const filterSortServiceTypes = (allServicesData, franchiseServices) => {
    franchiseServices = franchiseServices.map(a => a.service_line);
    return (
        allServicesData.filter(item => (
            !!item.franchise_service_mapping
            && item.franchise_service_mapping
                .split(',')
                .some(v => franchiseServices.includes(v))
        ))
    );
};

export const serviceLineMap = {
    "Commercial": "Commercial",
    "Water Damage": "Water Damage",
    "Fire Damage": "Fire Damage",
    "Mold Damage": "Mold Damage",
    "Storm Damage": "Storm Damage",
    "Construction": "Construction",
    "Air Duct/HVAC Cleaning": "Air Duct/HVAC Cleaning",
    "Biohazard/Crime Scene": "Biohazard/Crime Scene",
    "Carpet/Upholstery": "Carpet/Upholstery",
    "Ceiling/Floor/Walls": "Ceiling/Floor/Walls",
    "COVID Cleaning": "Virus/Pathogen Cleaning",
    "Document Restoration": "Document Restoration",
    "Drapes/Blinds": "Drapes/Blinds",
    "Odor Removal": "Odor Removal",
    "Roof Tarping/Board Up": "Roof Tarping/Board-Up",
    "Vandalism/Graffiti": "Vandalism/Graffiti"
};

export const subCategoryServiceLineToNavMenuUrlMap = {
    "Commercial": "/services/commercial",
    "Water Damage": "/services/water-damage",
    "Fire Damage": "/services/fire-damage",
    "Mold Damage": "/services/mold-remediation",
    "Storm Damage": "/services/storm-damage",
    "Construction": "/services/construction",
    "Air Duct/HVAC Cleaning": "/services/cleaning/specialty#airduct-cleaning",
    "Biohazard/Crime Scene": "/services/cleaning/specialty#biohazard-cleaning",
    "Carpet/Upholstery": "/services/cleaning/general#carpet-upholstery",
    "Ceiling/Floor/Walls": "/services/cleaning/general#ceilings-walls",
    "COVID Cleaning": "/services/cleaning/specialty#covid-cleaning",
    "Document Restoration": "/services/cleaning/specialty#document-restoration",
    "Drapes/Blinds": "/services/cleaning/general#drapes-blinds",
    "Odor Removal": "/services/cleaning/specialty#odor-removal",
    "Roof Tarping/Board Up": "/services/storm-damage#roof-tarping",
    "Vandalism/Graffiti": "/services/cleaning/specialty#vandalism-graffiti-cleanup"
};